<template>
    <div class="relative">
        <transition name="fade">
            <img v-show="!playerReady" src="/assets/img/lead-capture/video-play1.png" alt="Why Unbundled?" @click="playVideo" role="button" title="Play video" id="videoWhyUnbundled" class="absolute z-10">
        </transition>
        <!-- <vimeo-player v-show="clicked" ref="player" v-bind="playerOptions" @play="play" @ended="clicked = false"></vimeo-player> -->

        <div v-if="clicked" class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
            <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
                <div class="wistia_embed wistia_async_zyqsfis7fy videoFoam=true" style="height:100%;position:relative;width:100%">
                    <div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">
                        <img src="https://fast.wistia.com/embed/medias/zyqsfis7fy/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" />
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="relative w-full" style="padding:56.25% 0 0 0;"></div> <!-- preserve the document flow -->
    </div>
</template>

<script>
// import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
    // components: { vueVimeoPlayer },

    data() {
        return {
            clicked: false,
            playerReady: false,
            playerOptions: {
                videoId: '391066907',
                options: {
                    title: 0,
                    byline: 0,
                    portrait: 0,
                    responsive: true,
                    autoplay: true
                },
            }
        }
    },

    created() {
        window._wq = window._wq || [];
        _wq.push({ id: 'zyqsfis7fy', onReady: (video) => {
            this.playerReady = true;
        }});

        // pause the video whenever lead capture step changes
        this.$event.$on('step:on-step', (step) => {
            if (this.$refs.player) {
                this.$refs.player.pause();
            }
        });
    },

    methods: {
        async load_script(src) {
            return new Promise((resolve, reject) => {
                if (document.querySelectorAll(`script[src="${src}"]`).length > 0) {
                    resolve();
                    return;
                }

                const script = document.createElement('script');
                script.src = src;
                script.defer = true;

                script.onload = () => {
                    resolve();
                };

                script.onerror = () => {
                    reject(new Error(`Failed to load script ${src}`));
                };

                document.head.appendChild(script);
            });
        },

        playVideo() {
            this.load_script('https://fast.wistia.com/embed/medias/zyqsfis7fy.jsonp')
                .then(() => this.load_script('https://fast.wistia.com/assets/external/E-v1.js'))
                .then(() => this.clicked = true);
            // this.$refs.player.play();
        },

        play () {
            // if (!this.clicked) {
            //     this.$refs.player.pause();
            //     return;
            // }
        },
    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .25s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
</style>
